import { getRequestFilter } from '@/utils/data';
import { getApiQueryParams } from '@/utils/api';
import qs from 'qs';

export const factory = fetchApi => ({
  reportByMaterialsZgi: {
    // body = { date_from, date_to, order_type: string, system: id, sub_dealer: id, status: id }
    post: body => fetchApi.post('/api/reports/by-materials-zgi', body),
    // params = { date_from, date_to, order_type: string, system: id, sub_dealer: id, status: id }
    excelLink: params => {
      const paramsFilter = getRequestFilter(params);
      if (paramsFilter?.order_type !== 'from_dealers') {
        if (paramsFilter?.sub_dealer) {
          delete paramsFilter.sub_dealer;
        }
      }

      let result = '';

      for (const key in paramsFilter) {
        if (key) {
          const value = paramsFilter[key];
          const item = `${key}=${value}`;
          if (!result) {
            result += `?${item}`;
          } else {
            result += `&${item}`;
          }
        }
      }

      return '/account/reports/generate-report-materials-zgi-excel' + result;
    },
  },
  employees: {
    get: () => fetchApi.get('/api/employees'),
  },
  reports: {
    specialPrices: {
      get: () => fetchApi.get('/api/reports/special-prices'),
      generateExcel: () => '/account/reports/special-prices/generate-excel',
    },
  },
  wholesaleOrderOptItemsCategories: {
    get: () => fetchApi.get('/api/wholesale-order/opt/items-categories'),
  },
  wholesaleOrderItems: {
    get: async params => {
      const paramsStr = getApiQueryParams({
        params,
        requiredKeys: ['type', 'category_id', 'query'],
      });
      if (!paramsStr) {
        return;
      }

      return await fetchApi.get(`/api/wholesale-order/items${paramsStr}`);
    },
  },
  wholesaleOrderPathCalculate: {
    post: (path = '', body) => fetchApi.post(`/api/wholesale-order/${path}/calculate`, body),
  },
  wholesale: {
    order: {
      calculate: {
        post: (path, body) => fetchApi.post(`/api/wholesale-order/${path}/calculate`, body),
      },

      zgiModels: {
        get: () => fetchApi.get('/api/wholesale-order/zgi/models'),
      },

      zgiModelsIdMaterials: {
        get: materialId => fetchApi.get(`/api/wholesale-order/zgi/models/${materialId}/materials`),
      },
    },
  },
  photoGallery: {
    get: (params = {}) =>
      fetchApi.get(`/api/photo-gallery`, {
        params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        },
      }),
    post: body => fetchApi.post('/api/photo-gallery', body),
    models: {
      get: () => fetchApi.get('/api/photo-gallery/models'),
    },
    modelMaterials: {
      get: (modelId = '') => fetchApi.get(`/api/photo-gallery/model/${modelId}/materials`),
    },
    filter: {
      materials: {
        get: params => fetchApi.get('/api/photo-gallery/filter/materials', { params }),
      },
      systemsAndModels: {
        get: () => fetchApi.get('/api/photo-gallery/filter/systems-and-models'),
      },
    },
  },
  dealers: {
    getSubDealers: {
      get: params => {
        return fetchApi.get(`/api/dealers/get-sub-dealers`, {
          params,
          paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
          },
        });
      },
    },
    invoicesFormats: {
      get: () => fetchApi.get('/api/dealers/invoices-formats'),
    },
    uploadDealerPrice: {
      post: body => fetchApi.post('/api/dealers/upload-dealer-price', body),
    },
    shippingCompanies: {
      get: () => fetchApi.get('/api/dealers/shipping-companies'),
    },
    shippings: {
      get: () => fetchApi.get('/api/dealers/shippings'),
    },
    request: {
      shipping: {
        post: body => fetchApi.post('/api/dealers/request-shipping', body),
      },
    },
    production: {
      updateMaxCut: {
        post: (body = {}) => fetchApi.post('/api/dealers/production/update-max-cut', body),
      },
    },
    uploadedPrice: {
      delete: () => fetchApi.delete('/api/dealer-uploaded-price'),
    },
    uploadedStock: {
      delete: () => fetchApi.delete('/api/dealer-uploaded-stock'),
    },
    updateAll: {
      post: (body = {}) => fetchApi.post('/api/dealers/update-all', body),
    },
  },
  dealersId: {
    update: {
      post: (id, data) => fetchApi.post(`/api/dealers/${id}/update`, data),
    },
  },
  orderId: {
    downloadNotificationDocument: {
      post: (uuid, body = {}) =>
        fetchApi.post(`/api/orders/${uuid}/download-notification-document`, body, {
          responseType: 'blob',
        }),
    },
  },
  orders: {
    statuses: {
      get: () => fetchApi.get('/api/orders/statuses'),
    },
    changeStatus: {
      post: (id = '', body = {}) => fetchApi.post(`/api/orders/${id}/change-status`, body),
    },
    change: {
      post: (body = {}) => fetchApi.post('/api/orders/change', body),
    },
  },
  systems: {
    get: () => fetchApi.get('/api/systems'),
  },
  calculate: {
    options: {
      values: {
        post: body => fetchApi.post('/api/calculate-options-values', body),
      },
    },
  },
  visualizations: {
    download: {
      post: body => fetchApi.post('/api/visualizations/download', body),
    },
  },
});
